import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import putClient from "../../../API/Admin/PutClient";
import logout from "../../../Global/logout.js";
import Loader from "../../../Global/loader.js";
import { store } from "react-notifications-component";
import { AiOutlineFileAdd, AiOutlineSafetyCertificate } from "react-icons/ai";
import fileUpload from "../../../API/Admin/CertUpload.js";
import forge from "node-forge";
import { BsBackspaceFill } from "react-icons/bs";
import GetNewToken from "../../../API/Admin/GetNewToken";

class Opcenito extends React.Component {
  state = {
    message: "",
    loading: false,
    selectedFile: "",
    certPass: "",
  };

  componentDidMount() {}

  handleCertChange(e) {
    this.setState({
      [e.target.id]: e.target.value,
    });
  }

  handleChange(e) {
    this.props.mapState("ADMIN_CHANGE_ONE_CLIENT_DETAILS", e.target);
  }

  submitHandler = async (event) => {
    event.preventDefault();
    this.setState({
      loading: true,
    });

    let izmjena = await putClient(this.props.oneClientInfo);
    if (izmjena.data.responseMessage === "Invalid credentials.") {
      logout();
    }

    if (izmjena.data.status !== 200) {
      store.addNotification({
        title: "Greška!",
        message: izmjena.data.message,
        type: "danger",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          pauseOnHover: true,
        },
      });
    } else {
      store.addNotification({
        title: "Uspješno!",
        message: "Izmjena se uspješno spremila",
        type: "success",
        insert: "top",
        container: "top-right",
        animationIn: ["animate__animated", "animate__fadeIn"],
        animationOut: ["animate__animated", "animate__fadeOut"],
        dismiss: {
          duration: 5000,
          pauseOnHover: true,
        },
      });
    }

    this.setState({
      loading: false,
    });
  };

  // On file select (from the pop up)
  onFileChange = async (event) => {
    // Update the state
    await this.setState({ selectedFile: event.target.files[0] });
  };

  // On file upload (click the upload button)
  onFileUpload = async () => {
    await this.setState({
      loading: true,
    });

    /////////////////////////////////////////////////
    var file = this.state.selectedFile;

    var reader = new FileReader();

    reader.password = this.state.certPass;
    reader.oib = this.props.oneClientInfo.clientCountrySpecificVatNumber;
    reader.clientUuid = this.props.oneClientInfo.uuid;
    reader.selectedFile = this.state.selectedFile;

    reader.readAsArrayBuffer(file);

    reader.onload = async function () {
      try {
        // get p12 as ASN.1 object
        var p12Asn1 = forge.asn1.fromDer(
          forge.util.createBuffer(reader.result),
        );

        // decrypt p12 using the password returned by getPassword(), the password should be protected and not hard coded
        var p12 = forge.pkcs12.pkcs12FromAsn1(p12Asn1, this.password);

        //console.log(forge.pkcs12.pkcs12FromAsn1(p12Asn1, this.password ))
        // getting the key slot
        var bags = p12.getBags({
          friendlyName:
            p12.safeContents[1].safeBags[0].attributes.friendlyName[0],
        });
        //console.log(bags)
        var keyBag = bags.friendlyName[0];

        //console.log("certificateAlias: ", keyBag.attributes.friendlyName[0])
        let certificateAlias = keyBag.attributes.friendlyName[0];

        // Collect all 11-digit sequences from every cert in the p12 (Croatian OIB is 11 digits)
        // OIB may be in a different cert than the selected key (e.g. FISKAL 1 vs Fina RDC 2025)
        const oibCandidates = new Set();
        const addOibCandidates = (str) => {
          if (!str || typeof str !== "string") return;
          const digits = str.replace(/\D/g, "");
          if (digits.length === 11) oibCandidates.add(digits);
          if (digits.length > 11) {
            oibCandidates.add(digits.slice(-11));
            oibCandidates.add(digits.slice(0, 11));
          }
        };
        for (let i = 0; i < p12.safeContents.length; i++) {
          const content = p12.safeContents[i];
          for (let j = 0; j < content.safeBags.length; j++) {
            const bag = content.safeBags[j];
            if (bag.cert && bag.cert.subject) {
              (bag.cert.subject.attributes || []).forEach((attr) => {
                addOibCandidates(attr.value);
              });
            }
          }
        }

        const clientOib = String(this.oib ?? "").replace(/\D/g, "").trim();
        if (clientOib.length !== 11) {
          throw new Error("Unesite ispravan OIB klijenta (11 znamenki).");
        }
        if (oibCandidates.size === 0) {
          throw new Error(
            "U certifikatu nije pronađen OIB (11 znamenki u podaciju subjekta)."
          );
        }
        if (!oibCandidates.has(clientOib)) {
          throw new Error("OIB certifikata je različit od OIB klijenta");
        }

        // Create an object of formData
        const formData = await new FormData();

        // Update the formData object
        await formData.append(
          "file",
          this.selectedFile,
          this.selectedFile.name,
        );

        // Request made to the backend api
        const certUploaded = await fileUpload(
          this.clientUuid,
          formData,
          certificateAlias,
          this.password,
        );

        if (certUploaded.data.status !== 200) {
          store.addNotification({
            title: "Greška!",
            message: certUploaded.data.message,
            type: "danger",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              pauseOnHover: true,
            },
          });
        } else {
          store.addNotification({
            title: "Uspješno!",
            message: "Certifikat uspješno spremljen.",
            type: "success",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 5000,
              pauseOnHover: true,
            },
          });
        }
      } catch (error) {
        store.addNotification({
          title: "Greška!",
          message: error.message,
          type: "danger",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 10000,
            pauseOnHover: true,
          },
        });
      }
    };

    await this.setState({
      loading: false,
    });
  };

  getNewToken = async () => {
    this.setState({
      loading: true,
    });

    const newToken = await GetNewToken(this.props.oneClientInfo.uuid);

    alert("Novi token: " + newToken.data.data.token);

    this.setState({
      loading: false,
    });
  };

  goBack() {
    window.location = "#/Admin/client/";
  }

  render() {
    const { loading } = this.state;

    return (
      <>
        {loading ? (
          <Loader />
        ) : (
          <form style={{ padding: "40px" }}>
            <div className="row">
              <div className="col-sm-12 col-lg-6 col-md-12">
                <div className="form-group row">
                  <label
                    htmlFor="clientName"
                    className="col-sm-4 col-form-label"
                  >
                    Klijent
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="clientName"
                      type="text"
                      value={this.props.oneClientInfo.clientName}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="OIB" className="col-sm-4 col-form-label">
                    OIB
                  </label>
                  <div className="col-sm-8">
                    <input
                      maxLength="11"
                      minLength={11}
                      id="clientCountrySpecificVatNumber"
                      type="text"
                      value={
                        this.props.oneClientInfo.clientCountrySpecificVatNumber
                      }
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="Adresa" className="col-sm-4 col-form-label">
                    Adresa
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="clientFullAddress"
                      type="text"
                      value={this.props.oneClientInfo.clientFullAddress}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="PosBr" className="col-sm-4 col-form-label">
                    Email
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="contactEmail"
                      type="text"
                      value={this.props.oneClientInfo.contactEmail}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="PosBr" className="col-sm-4 col-form-label">
                    Telefon
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="contactPhoneNumber"
                      type="text"
                      value={this.props.oneClientInfo.contactPhoneNumber}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="pdv" className="col-sm-4 col-form-label">
                    PDV
                  </label>
                  <div className="col-sm-8">
                    <label className="form-check-label" htmlFor="gridCheck2">
                      <input
                        id="inVatSystem"
                        type="checkbox"
                        checked={this.props.oneClientInfo.inVatSystem}
                        onChange={(e) => this.handleChange(e)}
                      />
                      &nbsp;&nbsp; u sustavu pdv-a
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 col-lg-6 col-md-12">
                <div className="form-group row">
                  <label
                    htmlFor="clientVatNumber"
                    className="col-sm-4 col-form-label"
                  >
                    VAT
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="clientVatNumber"
                      type="text"
                      value={this.props.oneClientInfo.clientVatNumber}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="OIB" className="col-sm-4 col-form-label">
                    Domena
                  </label>
                  <div className="col-sm-8">
                    <input
                      id="domainLabel"
                      type="text"
                      value={this.props.oneClientInfo.domainLabel}
                      onChange={(e) => this.handleChange(e)}
                    />
                  </div>
                </div>
                <div className="form-group row">
                  <label htmlFor="Adresa" className="col-sm-4 col-form-label">
                    Tip
                  </label>
                  <div className="col-sm-8">
                    <span>{this.props.oneClientInfo.clientType}</span>
                  </div>
                </div>

                <div className="form-group row">
                  <label htmlFor="PosBr" className="col-sm-4 col-form-label">
                    Kreiran
                  </label>
                  <div className="col-sm-8" style={{ alignSelf: "center" }}>
                    <span>
                      {moment(this.props.oneClientInfo.created).format(
                        "DD.MM.YYYY",
                      )}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div className="form-group row justify-content-md-center">
              <div className="col-sm-2">
                <button
                  type="submit"
                  className="btn btn-info"
                  style={{ padding: "10px" }}
                  onClick={(e) => this.submitHandler(e)}
                >
                  Spremi
                </button>
              </div>
            </div>

            <br />
            <br />

            <div className="form-group row">
              <label htmlFor="PosBr" className="col-sm-2 col-form-label">
                Fisk. Certifikat
              </label>
              <div className="col-sm-4">
                <input
                  type="file"
                  name="uploadfile"
                  id="files"
                  style={{ display: "none" }}
                  onChange={this.onFileChange}
                />
                <label
                  className="btn btn-info"
                  htmlFor="files"
                  style={{ fontSize: "14px" }}
                >
                  <AiOutlineFileAdd size={20} />
                </label>
                &nbsp;
                {this.props.oneClientInfo.aliasName !== "" ? (
                  <label htmlFor="files">
                    {this.props.oneClientInfo.aliasName}
                    &nbsp;(
                    {new Date(
                      this.props.oneClientInfo.certificateValidTill,
                    ).toLocaleDateString("hr-HR")}
                    )
                  </label>
                ) : (
                  <label htmlFor="files">
                    {typeof this.state.selectedFile === "string"
                      ? "<- Učitaj Certifikat"
                      : this.state.selectedFile.name}
                  </label>
                )}
              </div>
              <button
                type="button"
                disabled={typeof this.state.selectedFile === "string"}
                className="btn btn-info col-sm-2"
                onClick={() => this.onFileUpload(this.state.certPass)}
              >
                <AiOutlineSafetyCertificate size={20} /> &nbsp; Upload cert.
              </button>
            </div>
            <div className="form-group row">
              <label htmlFor="certPass" className="col-sm-2 col-form-label">
                Lozinka
              </label>
              <div className="col-sm-4">
                <input
                  id="certPass"
                  type="text"
                  value={this.state.certPass}
                  onChange={(e) => this.handleCertChange(e)}
                />
              </div>
            </div>
            <div className="form-group row">
              <button
                type="button"
                className="btn btn-info col-sm-2"
                style={{ padding: "10px" }}
                onClick={() => this.getNewToken()}
              >
                Generiraj token
              </button>
            </div>
          </form>
        )}

        <div
          className="btn btn-default"
          style={{
            /*width: "100%",*/ marginBottom: "10px",
            marginTop: "10px",
          }}
          onClick={() => this.goBack()}
        >
          <BsBackspaceFill size={30} /> <strong>Nazad</strong>
        </div>
      </>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    oneClientInfo: state.adminClient.oneClient,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    mapState: (type, data) => dispatch({ type: type, data: data }),
    API: (type, data) => dispatch({ type: type, data: data }),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Opcenito);
